"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

var _ref2 = /*#__PURE__*/_jsx(_index.Icon, {
  name: "message"
});

var _ref3 = /*#__PURE__*/_jsx(_index.Icon, {
  name: "profile"
});

var UpsellDropdown = function UpsellDropdown(_ref) {
  var onLater = _ref.onLater,
      onRequestHelp = _ref.onRequestHelp,
      onAssignToColleague = _ref.onAssignToColleague,
      showLater = _ref.showLater,
      assignToAM = _ref.assignToAM,
      assignToColleague = _ref.assignToColleague,
      hideCardLabel = _ref.hideCardLabel,
      children = _ref.children,
      _ref$trigger = _ref.trigger,
      trigger = _ref$trigger === void 0 ? 'hover' : _ref$trigger,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'right-half-back' : _ref$align,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'top' : _ref$position,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      dataId = _ref.dataId;
  var options = [{
    label: assignToAM.label,
    align: 'left',
    description: assignToAM.disabled ? assignToAM.sentDescription : assignToAM.description,
    customIcon: _ref2,
    onClick: function onClick() {
      onRequestHelp();
    },
    disabled: assignToAM.disabled,
    separated: true
  }];

  if (assignToColleague.show) {
    options.unshift({
      label: assignToColleague.label,
      align: 'left',
      description: assignToColleague.description,
      customIcon: _ref3,
      onClick: function onClick() {
        onAssignToColleague();
      }
    });
  }

  if (showLater) {
    options.push({
      label: hideCardLabel,
      onClick: onLater
    });
  }

  return /*#__PURE__*/_jsx(_index.Dropdown, {
    trigger: trigger,
    align: align,
    position: position,
    size: size,
    options: options,
    rootDataId: dataId
  }, void 0, children);
};

UpsellDropdown.defaultProps = {
  assignToAM: {},
  assignToColleague: {}
};
var _default = UpsellDropdown;
exports["default"] = _default;